module.exports = __webpack_public_path__ + "static/media/bg-mission.e084067a.png";